(ns frontend.ui.component.lp-portal.strong-label.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]))

(defn strong-label
  []
  {:font-size      "12px"
   :font-weight    "bold"
   :text-transform "uppercase"
   :letter-spacing "2.2px"
   :color          (theme/color [:text-strong :primary :color])})
